import { Component, inject, OnInit } from "@angular/core";
import { DefaultComponent } from "@kpx/core";
import { QuickscanService } from "@kpx/quickscan";

@Component({
  selector: "app-authentication-failed",
  imports: [],
  templateUrl: "./authentication-failed.component.html",
  styleUrl: "./authentication-failed.component.less",
})
export class AuthenticationFailedComponent extends DefaultComponent implements OnInit {
  private quickscan: QuickscanService;
  public portalUrl: string | null;

  public constructor() {
    super();
    this.quickscan = inject(QuickscanService);
    this.portalUrl = null;
  }

  public ngOnInit(): void {
    // this.quickscan.config.pipe(filter((c) => !!c)).subscribe((c) => (this.portalUrl = c.PORTAL_URL));
    return;
  }

  public navigate(): void {
    if (this.portalUrl) {
      location.href = this.portalUrl;
    }
  }
}
